import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { BsCheck2 } from "react-icons/bs";
import { HashLink as Link } from 'react-router-hash-link';

import'./FeatureCard.css'

function FeatureCard(props) {

    const update = ()=>{
        props.config("FirstCard");
    }

    return (
        <div>
            <Container fluid style={{paddingBottom:'30px'}}>
                <Row>
                    <div className='AmenCont'>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply
                         random text. It has roots in a piece of classical Latin
                         literature from 45 BC, making it over 2000 years old. Richard
                         McClintock, a Latin professor at Hampden-Sydney College in Virginia,
                        looked up one of Contrary to popular belief, Lorem Ipsum is not simply
                        random text. It has roots in a piece of classical Latin literature from
                        45 BC, making it over 2000 years old. Richard</p>
                    </div>
                </Row>
                <Row>
                    <Col xl={4} lg={4} md={4} sm={6} xs={6}>
                        <div className='checkOuterBox'>
                            
                            <p><BsCheck2 /> Bathrooms with bathtub</p>
                        </div>
                        <div className='checkOuterBox'>
                            
                            <p><BsCheck2 /> Complimentary Wi-Fi</p>
                        </div>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={6} xs={6}>
                        <div className='checkOuterBox'>
                             
                             <p><BsCheck2 /> Tea & Coffee Maker</p>
                        </div>
                        <div className='checkOuterBox'>
                            
                            <p><BsCheck2 /> LCD TV with 24 hr cable connection</p>
                        </div>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={12} xs={12} className='featBox'>
                        <div className='checkOuterBox'>
                            
                            <p><BsCheck2 /> Iron & Ironing Board</p>
                        </div>
                        <div className='checkOuterBox'>
                            
                            <p><BsCheck2 /> Electronic safe</p>
                        </div>
                    </Col>
                </Row>
                <Row className='viewMoreRow'>
                    <Col>
                        <Button type='button' onClick={update} className='viewMore'  >View More Rates</Button>
                    </Col>
                </Row>

            </Container>
        </div>
    )
}

export default FeatureCard
